/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NotificationAppIcon16Light } from './NotificationAppIcon16Light';
import { NotificationAppIcon16Regular } from './NotificationAppIcon16Regular';
import { NotificationAppIcon16Solid } from './NotificationAppIcon16Solid';
import { NotificationAppIcon20Light } from './NotificationAppIcon20Light';
import { NotificationAppIcon20Regular } from './NotificationAppIcon20Regular';
import { NotificationAppIcon20Solid } from './NotificationAppIcon20Solid';
import { NotificationAppIcon24Regular } from './NotificationAppIcon24Regular';
import { NotificationAppIcon24Solid } from './NotificationAppIcon24Solid';
import { NotificationAppIcon32Regular } from './NotificationAppIcon32Regular';
import { NotificationAppIcon64Regular } from './NotificationAppIcon64Regular';
var sizes = {
    16: {
        light: NotificationAppIcon16Light,
        regular: NotificationAppIcon16Regular,
        solid: NotificationAppIcon16Solid,
    },
    20: {
        light: NotificationAppIcon20Light,
        regular: NotificationAppIcon20Regular,
        solid: NotificationAppIcon20Solid,
    },
    24: {
        regular: NotificationAppIcon24Regular,
        solid: NotificationAppIcon24Solid,
    },
    32: {
        regular: NotificationAppIcon32Regular,
    },
    64: {
        regular: NotificationAppIcon64Regular,
    },
};
export var NotificationAppIcon = forwardRef('NotificationAppIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
